import { render } from "./NavBarMenuDivider.vue?vue&type=template&id=27754e05"
const script = {}

import exportComponent from "/var/www/sites/dmsfrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__